'use strict';

var NotificationSystem = require('react-notification-system'),
    React = require('react'),
    {t} = require('services/i18nextWrapper'),
    Notification,
    {delay} = require('lodash/function');

const _resetThemeModal = {
    borderTop: 'none',
    backgroundColor: '#fff',
    boxShadow: '9px 20px 34px -5px gray'
};

const MAX_NOTIFICATION_ALLOW = 3;
let currentNotifications = [];

Notification = React.createClass({displayName: "Notification",

    _notificationSystem: null,

    showImmediately: function (message, type, autoDismiss, actionHandler) {
        var notificationConf = {
            message: `<div class="custom-notification"><i class="custom-notification__icon custom-notification__icon--${type || 'error'}"></i><span class="custom-notification__content">${message}</span></div>`,
            level: type || 'error',
            autoDismiss: type === 'error' ? false : autoDismiss || 10
        };
        currentNotifications.push(this._notificationSystem.addNotification(notificationConf));
        if (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
            while (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
                const lastNotification = currentNotifications.shift();
                this._notificationSystem.removeNotification(lastNotification); // remove last
            }
        }
    },

    show: function (message, type, autoDismiss, actionHandler) {
        delay(() => {
            var notificationConf = {
                message: `<div class="custom-notification"><i class="custom-notification__icon custom-notification__icon--${type || 'error'}"></i><span class="custom-notification__content">${message}</span></div>`,
                level: type || 'error',
                autoDismiss: type === 'error' ? false : autoDismiss || 10
            };

            currentNotifications.push(this._notificationSystem.addNotification(notificationConf));

            if (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
                while (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
                    const lastNotification = currentNotifications.shift();
                    this._notificationSystem.removeNotification(lastNotification); // remove last
                }
            }

        }, 100);
    },

    componentDidMount: function () {
        this._notificationSystem = this.refs.notificationSystem;
    },

    render: function () {

        var style = {
            NotificationItem: {
                info: _resetThemeModal,
                error: _resetThemeModal,
                warning: _resetThemeModal,
                success: _resetThemeModal,
                DefaultStyle: {
                    padding: '3px 0 0 0', //need to override with style 0
                    minHeight: '50px'
                }
            }
        };
        return (
            React.createElement("div", {className: "bp-notification-container"}, 
                React.createElement(NotificationSystem, {
                    className: "custom-notification", 
                    allowHTML: true, 
                    ref: "notificationSystem", 
                    onClick: function () {
                    }, 
                    style: style }
                )
            )
        );
    }
});

module.exports = Notification;



/** WEBPACK FOOTER **
 ** ./src/components/Notification/Notification.jsx
 **/